var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rec-main__app" },
    [
      _c(
        "div",
        { staticClass: "session-wrapper container" },
        [
          !_vm.user.recorder
            ? [
                _c("p", [
                  _vm._v(
                    "Recorder is not assigned. Please contact your system administrator."
                  ),
                ]),
              ]
            : !_vm.user.recorder.enabled
            ? [
                _c("p", [
                  _vm._v(
                    "Your account is partially disabled and you will not be able to perform any recording or live streaming activities."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "To fully enable your account, please contact our support organization."
                  ),
                ]),
              ]
            : [
                _c("session", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.recorderState === "READY",
                      expression: "recorderState === 'READY'",
                    },
                  ],
                  ref: "session",
                  attrs: { user: _vm.user },
                }),
                _vm._v(" "),
                _vm.recorderState === "PENDING"
                  ? _c("p", [
                      _vm._v(
                        "Your recorder is being provisioned. Please wait."
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.recorderState !== "READY"
                  ? _c("ui-progress", { attrs: { type: "dots" } })
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.user.recorder_id
        ? _c("media-list", {
            ref: "mediaList",
            staticClass: "media-list-wrapper container",
            attrs: {
              "recorder-api-url": _vm.recorderApiUrl,
              "recorder-id": _vm.user.recorder_id,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }